const slug = (s) => s.toLowerCase().replace(/&/g, "and").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

const Chip = ({ active, disabled, onClick, testid, children }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testid}
    aria-pressed={active}
    aria-disabled={disabled || undefined}
    className={`inline-flex shrink-0 items-center gap-1.5 rounded-full border px-4 py-2 text-base font-medium transition-colors ${ active ? "border-ink bg-ink text-sand" : disabled ? "border-border/60 bg-transparent text-olive/50" : "border-border bg-transparent text-ink hover:border-ink hover:bg-bone" }`}
  >
    {children}
  </button>
);

const Count = ({ n, active }) => (
  <span className={`ml-0.5 rounded-full px-1.5 text-[13px] font-semibold tabular-nums ${active ? "bg-sand/25 text-sand" : "bg-olive/12 text-olive"}`}>{n}</span>
);

/** Same chip tape as the /demo filters, for any dimension (schools, needs). */
export const FilterChips = ({ prefix, allLabel, options = [], counts = {}, selected, onSelect, ariaLabel }) => {
  if (options.length === 0) return null;
  const total = Object.values(counts).reduce((a, b) => a + (b || 0), 0);
  return (
    <div className="flex flex-wrap gap-2 pb-1" data-testid={`${prefix}-chips`} role="group" aria-label={ariaLabel}>
      <Chip active={selected == null} onClick={() => onSelect(null)} testid={`${prefix}-chip-all`}>
        {allLabel}<Count n={total} active={selected == null} />
      </Chip>
      {options.map((name) => {
        const n = counts[name] || 0;
        const active = selected === name;
        return (
          <Chip key={name} active={active} disabled={!active && n === 0} onClick={() => onSelect(active ? null : name)} testid={`${prefix}-chip-${slug(name)}`}>
            {name}<Count n={n} active={active} />
          </Chip>
        );
      })}
    </div>
  );
};
